import React from "react";

const TwitterIcon = () => {
	return (
		<svg
			width='36'
			height='37'
			viewBox='0 0 36 37'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_42_35)'>
				<path
					d='M18.0001 36.4997C27.9412 36.4997 36 28.4409 36 18.4998C36 8.5588 27.9412 0.5 18.0001 0.5C8.05911 0.5 0.000305176 8.5588 0.000305176 18.4998C0.000305176 28.4409 8.05911 36.4997 18.0001 36.4997Z'
					fill='#55ACEE'
				/>
				<path
					d='M29.0257 13.4361C28.2543 13.7781 27.4246 14.0094 26.5544 14.1128C27.4428 13.5804 28.1247 12.7382 28.4465 11.7329C27.6152 12.2261 26.694 12.5838 25.7144 12.7767C24.9295 11.9408 23.8113 11.4185 22.5731 11.4185C20.1974 11.4185 18.2706 13.3452 18.2706 15.7209C18.2706 16.0582 18.3088 16.3864 18.3826 16.7015C14.8069 16.5221 11.6364 14.8093 9.51424 12.2055C9.14396 12.8408 8.93155 13.5804 8.93155 14.3688C8.93155 15.8611 9.69168 17.1786 10.8455 17.95C10.1406 17.9278 9.4767 17.7343 8.8969 17.4112C8.89657 17.4295 8.89657 17.4478 8.89657 17.4658C8.89657 19.5504 10.3803 21.2892 12.3481 21.6842C11.9875 21.783 11.6066 21.8353 11.2148 21.8353C10.9369 21.8353 10.6677 21.8087 10.4053 21.7586C10.9527 23.4675 12.5413 24.7115 14.4244 24.7465C12.9517 25.9007 11.0967 26.5883 9.08043 26.5883C8.7339 26.5883 8.39057 26.5681 8.05463 26.528C9.95767 27.7492 12.2198 28.4612 14.6493 28.4612C22.5631 28.4612 26.891 21.9053 26.891 16.2192C26.891 16.0328 26.8868 15.847 26.8784 15.6628C27.7198 15.0564 28.4491 14.2989 29.0257 13.4361Z'
					fill='#F1F2F2'
				/>
			</g>
			<defs>
				<clipPath id='clip0_42_35'>
					<rect
						width='36'
						height='36'
						fill='white'
						transform='translate(0 0.5)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default TwitterIcon;
